export const SLOT_PER_MODULE = 2;
export const DECREASE_RAILS_TOP_SIZE_BY = 94;
export const HEIGHT_OF_ONE_RAIL_IN_PIXELS = 300;
export const HEIGHT_OF_ONE_COMB_RAIL_IN_PIXELS = 140;
export const HEIGHT_OF_ONE_POWER_TAG_RAIL_IN_PIXELS = 150;
export const DECREASE_COMBUS_BUSBAR_RAILS_TOP_SIZE_BY = 139;
export const DECREASE_POWER_TAG_RAILS_TOP_SIZE_BY = -120;
export const SPECIAL_DEVICES_LABELS_WIDTH_IN_PERCENTS = 0.08;

export const NUMBER_OF_RAILS_COVERED_BY_NOT_BREAKABLE_COVERS = 2;

export const HEIGHT_OF_COVERS_LABEL_ROW_IN_PIXELS = 70;

export const MAX_FIELD_ENCLOSURE_SIZE = 650;
export const MIN_FIELD_ENCLOSURE_SIZE = 30;

export const MAX_ALLOWED_LABEL_CHARACTERS = 6;
export const MAX_ALLOWED_FEED_IN_DESCRIPTION = 20;

export const WIDTH_OF_ONE_MODULE_IN_MM = 18;

export const PRISMA_XS_280_MM_DEPTH = 280;

export const SIDE_MENU_DIMENSIONS = {
  defaultSizeInPx: 300,
  initialSizeToParentContainerInPercents: 30,
  minSizeToParentContainerInPercents: 20,
  maxSizeToParentContainerInPercents: 50,
  maxSizeInPx: 1000,
  minSizeInPx: 100
}

export const ENCLOSURE_DEFAULT_DIMENSIONS = {
  oneFieldDefaultWidth: 839,
  oneFieldDefaultHeight: 503,
  rowDimensionsWidth: 733,
  rowSlotsWidth: 24
}

export const SPECIAL_KITS_RAILS_HEIGHT = [
  {
    reference: 'SZMT12230',
    height: 520,
    numberOfSlots: 1
  },
  {
    reference: 'SZMT22231',
    height: 341,
    numberOfSlots: 1
  },
  {
    reference: 'SZMT13250',
    height: 773,
    numberOfSlots: 1
  },
  {
    reference: 'SZMT22251',
    height: 447,
    numberOfSlots: 1
  },
  {
    reference: 'SZMT12130',
    height: 443,
    numberOfSlots: 1
  },
  {
    reference: 'SZMT22131',
    height: 469,
    numberOfSlots: 1
  },
  {
    reference: 'SZMT12220SE',
    height: 450,
    numberOfSlots: 1
  },
  {
    reference: 'SZMT22220SE',
    height: 450,
    numberOfSlots: 1
  },
  {
    reference: 'SZMT13150',
    height: 688,
    numberOfSlots: 1
  },
  {
    reference: 'SZMT22151',
    height: 688,
    numberOfSlots: 1
  }
];

export const ENCLOSURE_OPTIMAL_CAPACITY = 70;
export const PROJECT_LAYER_NOTIFICATION_ENC_ID = 0;

export const DOOR_TYPE = 1;
export const TRANSPARENT_DOOR = 3;
export const PLAIN_DOOR = 11;
export const VENTILATED_DOOR = 12;
export const VENTILATED = 13;
export const VENTILATED_MEDIA = 14;
export const TRANSPARENT_SMOKY = 26;

export const OCCUPANCY_THRESHOLD = 0.7;
